import { useState } from "react";
import List from "./List";
import New from "./New";
import Add from "../../../../../icons/add";

const Retos = () => {
  const [view, setView] = useState(false);
  const [counter, setCounter] = useState(0);

  return (
    <div className="flex flex-col w-full">
      <div className="flex items-center py-4">
        <p className="font-bold grow text-2xl">
          <strong>Retos</strong>
        </p>
        <div>
          <button onClick={() => setView(!view)} className="cefa-button">
            <p>Agregar Reto</p>
            <Add />
          </button>
        </div>
      </div>
      <New
        view={view}
        setView={setView}
        setCounter={setCounter}
        counter={counter}
      />
      <div className="flex-grow overflow-auto">
        <List counter={counter} setCounter={setCounter} />
      </div>
    </div>
  );
};

export default Retos;
